export enum SEASON {
  FALL = 1,
  SPRING = 2,
  SUMMER = 3,
}
